/**  
 * @Description <br/>
 * Spacing: _Define o espaço entre dois elementos._
 * 
 * @Available <br/>
 * _xs: 0.5rem | sl: 0.75rem | sm: 1rem | md: 1.5rem | lg: 2rem | xl: 2.5rem_
 * 
 * @Example <br/>
 * _Use spacings.xl para margin/padding = 2.5rem._
 */


export const spacings = {
  xs: "0.25rem",  // ${spacings.xs}
  sl: "0.5rem",   // ${spacings.sl}
  sm: "0.75rem",  // ${spacings.sm}
  md: "1rem",     // ${spacings.md}
  ls: "1.5rem",   // ${spacings.ls}
  lg: "2rem",     // ${spacings.lg}
  xl: "2.5rem",   // ${spacings.xl}
  xx: "3rem",     // ${spacings.xx}
  x2: "3.5rem",   // ${spacings.x2}
}